import * as React from 'react';

function SvgBetslipUk(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="1em" viewBox="0 0 32 32" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M26.6665 2.66663H5.33317C3.86317 2.66663 2.6665 3.86263 2.6665 5.33329V26.6666C2.6665 28.1373 3.86317 29.3333 5.33317 29.3333H6.83837C7.55064 29.3333 8.21984 29.056 8.72384 28.5521L11.1053 26.1713L13.4856 28.5528C13.9894 29.056 14.6601 29.3333 15.3722 29.3333H16.3982C17.113 29.3333 17.7837 29.0553 18.2862 28.5514L20.6665 26.1712L23.0441 28.5488C23.5493 29.0546 24.2225 29.3333 24.9373 29.3333H26.6665C28.1365 29.3333 29.3332 28.1373 29.3332 26.6666V5.33329C29.3332 3.86263 28.1365 2.66663 26.6665 2.66663ZM26.6665 26.6666L24.9296 26.6634L20.6665 22.4004L16.3982 26.6666L15.3696 26.666L11.1053 22.4004L6.83837 26.6666H5.33317V5.33329H26.6665V26.6666Z"
        fill="currentColor"
      />
      <path
        d="M9.33317 11.6666H22.6665C23.2186 11.6666 23.6665 11.2188 23.6665 10.6666C23.6665 10.1145 23.2186 9.66663 22.6665 9.66663H9.33317C8.78104 9.66663 8.33317 10.1145 8.33317 10.6666C8.33317 11.2188 8.78104 11.6666 9.33317 11.6666Z"
        fill="currentColor"
      />
      <path
        d="M9.33317 18.3333H17.3332C17.8853 18.3333 18.3332 17.8854 18.3332 17.3333C18.3332 16.7812 17.8853 16.3333 17.3332 16.3333H9.33317C8.78104 16.3333 8.33317 16.7812 8.33317 17.3333C8.33317 17.8854 8.78104 18.3333 9.33317 18.3333Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgBetslipUk;
